import { render, staticRenderFns } from "./loginFrom.vue?vue&type=template&id=3f2a56dd&scoped=true"
import script from "./loginFrom.vue?vue&type=script&lang=js"
export * from "./loginFrom.vue?vue&type=script&lang=js"
import style0 from "./loginFrom.vue?vue&type=style&index=0&id=3f2a56dd&prod&lang=scss&scoped=true"
import style1 from "./loginFrom.vue?vue&type=style&index=1&id=3f2a56dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2a56dd",
  null
  
)

export default component.exports